module.exports = __webpack_public_path__ + "static/media/icon-lock.4a5058be.svg";